import rambleWordmark from "./ramble-wordmark.svg?url"

export default {
  src: rambleWordmark,
  width: 599,
  height: 105,
}
